<template>
  <div class="container bg-white pt-5">
    <div class="row">
      <div class="col-md-6">
        <sector-returns></sector-returns>
      </div>

      <div class="col-md-6">
       <sector-volume></sector-volume>
      </div>
    </div>
  </div>
</template>

<script>
import SectorVolume from './SectorVolume.vue';
import SectorReturns from './SectorReturns.vue'
export default {
  components: {
    SectorReturns,
    SectorVolume
  },
};
</script>

<style scoped>

</style>>

